import { render, staticRenderFns } from "./CartOrder.vue?vue&type=template&id=0a13f588&"
import script from "./CartOrder.vue?vue&type=script&lang=ts&"
export * from "./CartOrder.vue?vue&type=script&lang=ts&"
import style0 from "./CartOrder.vue?vue&type=style&index=0&id=0a13f588&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon})
